module.exports = __webpack_public_path__ + "img/moon-haedbg.3a5eb85.webp";